var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.41 18.88a3.88 3.88 0 0 1 3.87-3.87 3.88 3.88 0 0 1 3.87 3.87 3.88 3.88 0 0 1-3.87 3.87 3.88 3.88 0 0 1-3.87-3.87zm1.5 0c0 1.31 1.06 2.37 2.37 2.37s2.37-1.06 2.37-2.37-1.06-2.37-2.37-2.37-2.37 1.06-2.37 2.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65 18.88V6.3c0-1.58.95-2.82 2.47-3.23l6.24-1.7c1.27-.35 2.34-.22 3.09.36.76.58 1.14 1.55 1.14 2.88v12.2c0 .41-.34.75-.75.75s-.75-.34-.75-.75V4.6c0-.58-.1-1.34-.55-1.68-.49-.38-1.33-.23-1.79-.1l-6.24 1.7c-.87.24-1.36.89-1.36 1.79v12.58c0 .4-.34.74-.75.74s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.85 16.8a3.88 3.88 0 0 1 3.87-3.87 3.88 3.88 0 0 1 3.87 3.87 3.88 3.88 0 0 1-3.87 3.87 3.88 3.88 0 0 1-3.87-3.87zm1.5 0c0 1.31 1.06 2.37 2.37 2.37s2.37-1.06 2.37-2.37-1.06-2.37-2.37-2.37-2.37 1.06-2.37 2.37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68 9.72c-.11-.4.12-.82.52-.93l11.44-3.12a.75.75 0 1 1 .39 1.45L9.6 10.24c-.07.02-.14.03-.2.03-.33 0-.63-.22-.72-.55z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMusic);
export default __webpack_public_path__ + "static/media/vuesax-outline-music.4f743dc2365878205b5c2eb51b82caef.svg";
export { ForwardRef as ReactComponent };